<template>
    <div class="">
        <input type="radio" :name="name" :id="value" class="hidden" />
        <label
            :for="value"
            @click="
                () => {
                    $emit('click')
                    $emit('select', value)
                }
            "
            :class="
                `${
                    active ? 'bg-orange-pale border-orange-pale' : 'bg-transparent border-snow-200'
                } flex items-center border rounded-lg px-4 py-8 h-16 cursor-pointer duration-300 w-full`
            "
        >
            <slot></slot>
        </label>
    </div>
</template>

<script>
export default {
    name: 'BillerRadio',
    model: {
        prop: 'modelValue',
        event: 'change',
    },
    props: {
        name: String,
        id: String,
        value: String,
        modelValue: String,
        active: Boolean,
    },
}
</script>

<style lang="scss" scoped></style>
